import React from "react";
// hook
import { useStyles } from "../hooks/table.useStyles";
// language
import { useLocale } from "../../../modules/hooks/UseLocale";
// UI
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
// method
import { setSortData } from "../methods/common.methods";
// constants
import { TabKey } from "../MasterMaintenance.constants";

export const MasterMaintenanceLaborMasterTbody = (props: any) => {
  const { pageInfo, order, orderBy,serviceCenterDataList } = props;
  const classes = useStyles();
  const { t } = useLocale({
    defaultPath: "modules.components.MasterMaintenance.laborMaster",
  });

  return (
    <TableBody>
      {setSortData(props.data, order, orderBy)
        .slice(
          pageInfo.page * pageInfo.rowsPerPage,
          pageInfo.page * pageInfo.rowsPerPage + pageInfo.rowsPerPage
        )
        .map((row: any, index: number) => {
          return (
            <TableRow className={classes.tbody} hover tabIndex={-1} key={index}>
              <TableCell className={classes.nowrap}>{row.model_no}</TableCell>
              <TableCell className={classes.nowrap}>
                {row.error_description}
              </TableCell>
              <TableCell className={classes.nowrap}>
                {row.labor_value}
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<EditIcon />}
                  onClick={() => props.handleEdit(row, TabKey.laborMaster)}
                >
                  {t("edit")}
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<DeleteIcon />}
                  onClick={() => props.handleDelete(row)}
                >
                  {t("delete")}
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
    </TableBody>
  );
};
